declare namespace $ {

	export class $bog_max_pick extends $bog_max_select {
		filter_hint( ): string
		custom( next?: string ): string
		custom_prefix( ): string
	}
	
}

//# sourceMappingURL=pick.view.tree.d.ts.map